<template>
  <div class="footer-persons">
    <span :class="stepperTitleClass"> Участники </span>
    <UiStepper
      :key="stepperKey"
      data-test="persons-count-stepper"
      class="footer-persons-count__stepper"
      :value="categoryStore.tmpFilters[EExperienceFilterType.PERSONS].persons"
      :min-value="1"
      :max-value="50"
      @input="updatePersons"
    />
  </div>
</template>

<script setup lang="ts">
  import { UiStepper } from '@experience/core-stepper-ui';
  import { useCategoryStore } from '@/shared/store';
  import { EExperienceFilterType } from '@/widgets/filtersBlock';
  import { ref, watch, computed } from 'vue';

  interface Props {
    boldTitle?: boolean;
  }
  const props = defineProps<Props>();

  const categoryStore = useCategoryStore();

  const stepperKey = ref(1);
  const stepperTitleClass = computed(() => ['footer-persons__title', props.boldTitle && 'bold-title']);

  const updatePersons = (value: number) => {
    categoryStore.setPersons(value);
  };

  watch(
    () => categoryStore.tmpFilters[EExperienceFilterType.PERSONS].persons,
    (newPersons: number) => {
      const focusElId = document.activeElement?.id;

      // TODO: разобрасться, почему при изменение filtersStore.state.date.persons не обновляется число в UiStepper
      // пока что обновлять значение при сбросе через кнопку
      if (newPersons === 1 && !focusElId?.startsWith('stepper')) {
        setTimeout(() => {
          stepperKey.value += 1;
        }, 50);
      }
    },
  );
</script>

<style scoped lang="scss">
  @use '@experience/shared/dist/assets/adaptivity' as adaptivity;
  @use '@experience/design-tokens/typography' as typography;

  .footer-persons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    @include adaptivity.mobile {
      margin-top: 0;
    }
  }

  .footer-persons-count__stepper {
    touch-action: manipulation;
  }

  .footer-persons__title {
    font-size: 17px;
    line-height: 24px;

    &.bold-title {
      @include typography.base-400-400-semi;
    }
  }
</style>
